import type { HekateDisplayForm } from '@onshape/www-inertia';
import type { Ref } from 'vue';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import type UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import AbstractSignupScreenWithNewsletterForm from './AbstractSignupScreenWithNewsletterForm';

export default class SubmittingFormLoadingSignupScreen extends AbstractSignupScreenWithNewsletterForm {
  public screenName: UnifiedSignupScreenName = 'uss-signup-email-status';

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
    signupSurveyDiv,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    isBackButtonHidden: Ref<boolean>;
    signupSurveyDiv: HTMLDivElement | null;
  }) {
    super({
      sessionInfo,
      formDefinition,
      isBackButtonHidden,
      signupSurveyDiv,
    });
  }

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public getProgress(): number {
    throw new Error('not implemented');
  }

  public override updateProgress(): void {
    const container = document.querySelector('.hekate-progress-bar') as HTMLDivElement;
    container.classList.remove('d-none');
  }

  public predicate(): boolean {
    const { submitFormResult, emailStatus } = this.sessionInfo.value;

    if (
      emailStatus !== null ||
      submitFormResult === null ||
      !submitFormResult.isSuccess ||
      submitFormResult.statusCode !== 201
    ) {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    return true;
  }
}
